import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '../services/navigation/navigation.service';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
import * as i2 from "../services/navigation/navigation.service";
import * as i3 from "@angular/router";
var AuthenticatedGuard = /** @class */ (function () {
    function AuthenticatedGuard(authenticationService, navigationService, router) {
        this.authenticationService = authenticationService;
        this.navigationService = navigationService;
        this.router = router;
    }
    AuthenticatedGuard.prototype.canActivate = function (_route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, navigationItem, hasPermission, hasFeatureFlagProperty, hasFeatureFlag, firstVisibleItem;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.authenticationService.user;
                        if (!user) {
                            return [2 /*return*/, this.redirectToLogin(state)];
                        }
                        navigationItem = this.navigationService.getItemByUrl(state.url);
                        if (!navigationItem) {
                            return [2 /*return*/, true];
                        }
                        hasPermission = navigationItem.permissionName ? this.authenticationService.hasPermission(navigationItem.permissionName) : true;
                        hasFeatureFlagProperty = Boolean(navigationItem.featureFlag);
                        hasFeatureFlag = hasFeatureFlagProperty && this.authenticationService.hasFlags(navigationItem.featureFlag);
                        if (hasPermission && (!hasFeatureFlagProperty || hasFeatureFlag)) {
                            return [2 /*return*/, true];
                        }
                        firstVisibleItem = this.navigationService.getFirstVisibleItem();
                        if (firstVisibleItem) {
                            location.href = firstVisibleItem.url;
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.authenticationService.logout()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.redirectToLogin(state)];
                }
            });
        });
    };
    AuthenticatedGuard.prototype.redirectToLogin = function (state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (location.href.endsWith('/404')) {
                            return [2 /*return*/];
                        }
                        localStorage.setItem('REDIRECT_TO_URL_AFTER_LOGIN', location.href);
                        return [4 /*yield*/, this.router.navigateByUrl('/login')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AuthenticatedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticatedGuard_Factory() { return new AuthenticatedGuard(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.NavigationService), i0.ɵɵinject(i3.Router)); }, token: AuthenticatedGuard, providedIn: "root" });
    return AuthenticatedGuard;
}());
export { AuthenticatedGuard };
